import { useHandoffMachine } from '../../components/machine-provider';

export default useHandoffMachine;
